module.exports = __webpack_public_path__ + "static/hero-e313a04f06785de19ac6b867d19f7191.jpg";